import { render } from "./Navbar.vue?vue&type=template&id=3f006cf0"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=3f006cf0&lang=css"

import exportComponent from "C:\\Users\\marti\\Documents\\dev\\JavaScript\\live-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__